module.exports = __webpack_public_path__ + "img/stripes.c6a96834.jpeg";